import { ReleasePlanStatus } from "../../../api/api";
import StatusChip from "../../../common/components/StatusChip";

interface ReleasePlanStatusChipProps {
	status?: ReleasePlanStatus;
	size?: "small" | "medium";
}

const statusColors: Record<string, "success" | "info" | "error" | "default"> = {
	[ReleasePlanStatus.Completed]: "success",
	[ReleasePlanStatus.InProgress]: "info",
	[ReleasePlanStatus.Failed]: "error",
	[ReleasePlanStatus.Pending]: "default",
};

const statusLabels: Record<string, string> = {
	[ReleasePlanStatus.Completed]: "Completed",
	[ReleasePlanStatus.InProgress]: "In Progress",
	[ReleasePlanStatus.Failed]: "Failed",
	[ReleasePlanStatus.Pending]: "Pending",
};

export default function ReleasePlanStatusChip({ status, size = "small" }: ReleasePlanStatusChipProps) {
	if (!status) return null;
	const label = statusLabels[status] || status;
	return <StatusChip status={label} colorMap={statusColors} defaultColor="default" size={size} sx={{ fontSize: "0.7rem" }} />;
}
